export default __webpack_public_path__ + "static/media/BunbaoSmall.78acc40a.png";